import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination, Button } from '@mui/material';
import { useState } from 'react';
import BatchUpdateAmbassadorDeposit from './BatchUpdateAmbassadorDeposit';
import UpdatePopup from './UpdatePopup';

const columns = [
    { id: 'id', label: 'ID', minWidth: 120 },
    { id: 'referrerClientName', label: 'Referrer Customer Name', minWidth: 170 },
    { id: 'referrerCustomerLoginUserName', label: 'Referrer Login User Name', minWidth: 170 },
    { id: 'refereeClientName', label: 'Referee Customer Name', minWidth: 170 },
    { id: 'refereeCustomerLoginUserName', label: 'Referee Login User Name', minWidth: 170 },
    { id: 'statusName', label: 'Status', minWidth: 170 },
    { id: 'amount', label: 'Amount', minWidth: 170 },
    { id: 'createdDate', label: 'Created Date', minWidth: 170, type: 'date' },
    { id: 'createdBy', label: 'Created By', minWidth: 170 },
    { id: 'updatedDate', label: 'Updated Date', minWidth: 170, type: 'date' },
    { id: 'updatedBy', label: 'Updated By', minWidth: 170 },
    { id: 'approvedDate', label: 'Approved Date', minWidth: 170, type: 'date' },
    { id: 'bankVendorName', label: 'Bank', minWidth: 170 },
    { id: 'bankAccountHolderName', label: 'Bank Account Holder Name', minWidth: 170 },
    { id: 'bankAccountNumber', label: 'Bank Account Number', minWidth: 170 }
];

function StickyHeadTable({ ambassadorDepositIncentives, fetchAmbassadorDepositIncentives, status }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {ambassadorDepositIncentives.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        let value = row[column.id];
                                        if (column.type && column.type === 'date') {
                                            if (value) {
                                                const timeString12hr = new Date(
                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                });
                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                            }
                                        }
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {typeof value === 'boolean'
                                                    ? value.toString()
                                                    : column.format && typeof value === 'number'
                                                    ? column.format(value)
                                                    : !value
                                                    ? '-'
                                                    : value}
                                                {/* {column.format && typeof value === 'number' ? column.format(value) : value} */}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            <BatchUpdateAmbassadorDeposit
                                                row={row}
                                                fetchAmbassadorDepositIncentives={fetchAmbassadorDepositIncentives}
                                                status={status}
                                            />
                                            <UpdatePopup
                                                row={row}
                                                fetchAmbassadorDepositIncentives={fetchAmbassadorDepositIncentives}
                                                status={status}
                                            />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={ambassadorDepositIncentives.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default StickyHeadTable;
